<template>
  <div>
    <div class="master-detail-caption"></div>
    <DxDataGrid
      :data-source="paymentRecords"
      :show-borders="true"
      key-expr="Id"
      :column-auto-width="true"
      @row-updating="onRowUpdating"
      @cell-prepared="onCellPrepared"
      ref="dataGridDetail"
    >
      <DxEditing :allow-updating="true" mode="batch" :use-icons="true" />
      <!-- <DxGrouping :auto-expand-all="false"/>               -->
      <!-- <DxColumn data-field="Id" caption="Id"  :allow-editing="false" alignment="center"/>     -->
      <DxColumn
        data-field="ContractDto.ParentDto.FullName"
        caption="Ωφελούμενη/ος"
        :allow-editing="false"
        alignment="left"
        width="230px"
      />
      <DxColumn
        data-field="ContractDto.KidDto.KidFullName"
        caption="Εξυπηρετούμενο Άτομο"
        :allow-editing="false"
        alignment="left"
        width="230px"
      />
      <DxColumn
        data-field="ContractDto.StructureDto.Description"
        caption="Δομή"
        :group-index="0"
        :allow-editing="false"
        alignment="left"
      />
      <DxColumn
        data-field="ContractDto.ContractCategoryDto.Description"
        caption="Κατηγορία θέσης"
        :group-index="1"
        :allow-editing="false"
        alignment="left"
      />
      <DxColumn
        data-field="ReceiptNumber"
        caption="Αρ.Παραστατικού"
        :allow-editing="!this.templateData.data.IsFinalized"
        alignment="left"
        width="180px"
      />
      <DxColumn
        data-field="ReceiptDate"
        caption="Ημ.Έκδοσης"
        data-type="date"
        format="dd/MM/yyyy"
        :allow-filtering="true"
        :allow-editing="!this.templateData.data.IsFinalized"
        alignment="center"
        width="150px"
      />
      <DxColumn
        data-field="Amount"
        caption="Ποσό"
        data-type="number"
        decimalSeparator=","
        alignment="right"
        width="130px"
        :allow-editing="false"
      >
        <DxFormat type="currency" currency="EUR" :precision="2" />
      </DxColumn>
    </DxDataGrid>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormat,
} from "devextreme-vue/data-grid";
import "devextreme/integration/jquery";
import notify from "devextreme/ui/notify";
import { dateWithoutTime } from "../shared/dateHelpers";
import config from "devextreme/core/config";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxFormat,
  },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    duplicateReceiptNumbers: {
      type: Array,
      default: () => [{}],
    },
  },
  data() {
    return {
      paymentRecords: [],
    };
  },
  methods: {
    async onCellPrepared(e) {
      if (this.templateData.data.FinalizeCheck == true) {
        if (e.rowType == "data" && e.column.dataField == "ReceiptDate") {
          var today = new Date();
          var selectedDate = new Date(e.value);
          var dateToCheckWith = new Date(
            this.templateData.data.PaymentYear,
            this.templateData.data.PaymentMonth - 1,
            1
          );
          if (
            selectedDate > today ||
            selectedDate < dateToCheckWith ||
            e.value == null
          ) {
            e.cellElement.addClass("invalidCell");
          }
        }
        if (e.rowType == "data" && e.column.dataField == "ReceiptNumber") {
          var test = this.duplicateReceiptNumbers;
          var isDuplicate = test.find(
            (x) =>
              x.Item1 == e.value &&
              x.Item2 == e.row.data.ContractDto.StructureId
          );
          if (isDuplicate || e.value == null || e.value == "")
            e.cellElement.addClass("invalidCell");
        }
      }
    },
    async getPaymentRecords() {
      this.paymentRecords = [];
      var paymentId = this.templateData.data.Id;
      var res = await mainService.get(
        `/Payments/GetPaymentRecords?paymentId=${paymentId}`
      );
      this.paymentRecords = res.data;
    },

    async onRowUpdating(e) {
      //corect strange behaviour of devexpress datepicker
      //see: https://supportcenter.devexpress.com/ticket/details/t977470/datebox-is-always-one-day-behind
      if (e.newData.ReceiptDate != null)
        e.newData.ReceiptDate = dateWithoutTime(e.newData.ReceiptDate);

      //trim whitespaces
      if (e.newData.ReceiptNumber != null) {
        e.newData.ReceiptNumber = e.newData.ReceiptNumber.trim();
        e.newData.ReceiptNumber = e.newData.ReceiptNumber.replace(
          / +(?= )/g,
          ""
        );
      }

      var paymentRecord = Object.assign(e.oldData, e.newData);

      try {
        const res = await mainService.post(
          "/Payments/UpdatePaymentRecord",
          paymentRecord
        );
        if (res.status != 200) {
          e.cancel = true;
          notify("Πρόβλημα κατά την αποθήκευση", "error", 2000);
          this.getPaymentRecords();
        }
        notify("Η αποθήκευση έγινε επιτυχώς!", "success", 2000);
        this.$emit("detailSaved", this.templateData.data.Id);
        var test = e;
      } catch (error) {
        console.log(error);
        e.cancel = true;
      }
    },
    isFinalized(e) {
      var isFinalized = e.row.IsFinalized;
      return isFinalized;
    },
    SavePendingChanges(e) {
      debugger;
      e.component.saveEditData();
    },
  },
  async mounted() {
    this.getPaymentRecords();
  },
};
</script>

<style>
.dx-toolbar-text-auto-hide .dx-button .dx-button-text {
  display: inline;
}

.invalidCell {
  border: 2px solid #dc3545 !important;
}
</style>